import React from 'react';
import classNames from 'classnames';

import { makeStyles } from '@material-ui/core';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import locales from '../../../locales';

const useStyles = makeStyles({
  paddingLeft: {
    paddingLeft: 24,
  },
});

const rows: Array<{
  id: string;
  sortable: boolean;
  label: string;
  last?: boolean;
  first?: boolean;
}> = [
  {
    id: 'date', sortable: true, label: locales.t('userStatistic.reserveTable.date'), first: true,
  },
  { id: 'status', sortable: false, label: locales.t('userStatistic.reserveTable.status') },
  { id: 'name', sortable: false, label: locales.t('userStatistic.reserveTable.persons') },
  { id: 'check', sortable: false, label: locales.t('userStatistic.reserveTable.check') },
  { id: 'source', sortable: false, label: locales.t('userStatistic.reserveTable.source') },
  {
    id: 'empty', sortable: false, label: '', last: true,
  },
];

interface Props {
  onRequestSort: (event: any, property: any) => void;
  order: 'asc' | 'desc';
  orderBy: string;
}

const StatisticReserveTableHead: React.FC<Props> = (props) => {
  const { onRequestSort, order, orderBy } = props;
  const classes = useStyles();

  const createSortHandler = (property: any) => (event: any) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead style={{ backgroundColor: '#F2F2F2' }}>
      <TableRow>
        {rows.map(row => (
          <TableCell
            key={row.id}
            align="left"
            padding={row.last ? 'none' : 'default'}
            className={classNames({ [classes.paddingLeft]: row.first })}
            sortDirection={orderBy === row.id ? order : false}
          >
            {row.sortable
              ? (
                <TableSortLabel
                  active={orderBy === row.id}
                  direction={order}
                  onClick={createSortHandler(row.id)}
                >
                  {row.label}
                </TableSortLabel>
              )
              : (<span>{row.label}</span>)
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default StatisticReserveTableHead;
